import {
  CHANGE_THEME_TO_DARK,
  CHANGE_THEME_TO_LIGHT,
} from '../actions/themeActions';

const initialState = {
  className: 'theme-light',
};

// init className for theme
document.body.classList.add(initialState.className);

export default function (state = initialState, action) {
  switch (action.type) {
    case CHANGE_THEME_TO_DARK: {
      // quick hotfix for modals (this is safe to do because body is outside of Virtual Dom)
      document.body.classList.replace('theme-light', 'theme-dark');
      return { className: 'theme-dark' };
    }
    case CHANGE_THEME_TO_LIGHT: {
      document.body.classList.replace('theme-dark', 'theme-light');
      return { className: 'theme-light' };
    }
    default:
      return state;
  }
}
